"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginGroupSourcePrefix = exports.GroupSource = exports.SyncableType = void 0;
var SyncableType;
(function (SyncableType) {
    SyncableType["Team"] = "team";
    SyncableType["Channel"] = "channel";
})(SyncableType || (exports.SyncableType = SyncableType = {}));
/**
 * Main sources for groups
 */
var GroupSource;
(function (GroupSource) {
    GroupSource["Ldap"] = "ldap";
    GroupSource["Custom"] = "custom";
})(GroupSource || (exports.GroupSource = GroupSource = {}));
/**
 * Special prefixes that can be added to group sources when they come from plugins
 * Used for identifying plugin-created groups by checking if source starts with this prefix
 */
var PluginGroupSourcePrefix;
(function (PluginGroupSourcePrefix) {
    PluginGroupSourcePrefix["Plugin"] = "plugin_";
})(PluginGroupSourcePrefix || (exports.PluginGroupSourcePrefix = PluginGroupSourcePrefix = {}));
